"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableRow = exports.EditableRowContainer = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var EditableColumn_1 = require("./EditableColumn");
exports.EditableRowContainer = styled_components_1.default.div.attrs({
    className: 'tws-editable-row',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: table-row;\n\t", "\n\t&& .tws-editable-column label {\n\t\t", ";\n\t}\n\t&.duplicated {\n\t\tcolor: #bbbbbb;\n\n\t\tlabel {\n\t\t\tcolor: #bbbbbb;\n\t\t}\n\t\ti {\n\t\t\tcolor: #bbbbbb;\n\t\t}\n\t}\n"], ["\n\tdisplay: table-row;\n\t", "\n\t&& .tws-editable-column label {\n\t\t", ";\n\t}\n\t&.duplicated {\n\t\tcolor: #bbbbbb;\n\n\t\tlabel {\n\t\t\tcolor: #bbbbbb;\n\t\t}\n\t\ti {\n\t\t\tcolor: #bbbbbb;\n\t\t}\n\t}\n"])), function (props) { return (props.deleted ? 'background-color: #eeeeee;' : ''); }, function (props) { return (props.deleted ? 'text-decoration: line-through;' : ''); });
exports.EditableRowContainer.displayName = 'EditableRowContainer';
var EditableRow = /** @class */ (function (_super) {
    __extends(EditableRow, _super);
    function EditableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            record: _this.props.record,
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onColumnBlur = _this.onColumnBlur.bind(_this);
        _this.onPaste = _this.onPaste.bind(_this);
        _this.handleOnSelect = _this.handleOnSelect.bind(_this);
        return _this;
    }
    EditableRow.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({ record: nextProps.record });
    };
    EditableRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, editMode = _a.editMode;
        var record = this.state.record;
        var EditableColumnType = (React.createElement(EditableColumn_1.EditableColumn, null)).type;
        var children = React.Children.map(this.props.children, function (child) {
            if (child) {
                if (child.type === EditableColumnType) {
                    return React.cloneElement(child, __assign(__assign({ onBlur: _this.onColumnBlur, onChange: _this.onChange, onPaste: _this.onPaste, onSelect: _this.handleOnSelect }, child.props), { deleted: _this.props.deleted, duplicated: _this.props.duplicated, record: record }));
                }
                else {
                    return React.cloneElement(child, __assign({}, child.props));
                }
            }
            else {
                return null;
            }
        });
        return (React.createElement(exports.EditableRowContainer, { isEditing: editMode, className: className }, children));
    };
    EditableRow.prototype.onColumnBlur = function (columnKey, text, event) {
        var _a = this.props, isEmptyRow = _a.isEmptyRow, onAppend = _a.onAppend, onDelete = _a.onDelete, onUpdate = _a.onUpdate;
        var record = this.state.record;
        // Check if either of the required columns has value
        var requireFields = this.props.requireFields;
        var eitherFieldHasValue = false;
        if (requireFields && requireFields.length > 0) {
            requireFields.forEach(function (field) {
                if (record && record[field] && record[field] !== '') {
                    eitherFieldHasValue = true;
                }
            });
            if (eitherFieldHasValue) {
                if (onAppend && isEmptyRow) {
                    onAppend(columnKey, record, event);
                }
                else if (onUpdate) {
                    onUpdate(columnKey, record, event);
                }
            }
            else {
                if (!isEmptyRow && record.isNew && onDelete) {
                    // Remove the row if all required columns have empty value
                    onDelete(record, event);
                }
                if (!record.isNew && onUpdate) {
                    onUpdate(columnKey, record, event);
                }
            }
        }
    };
    EditableRow.prototype.onChange = function (columnKey, text, event) {
        var record = this.state.record;
        if (record) {
            record[columnKey] = text;
        }
        this.setState({ record: record });
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(record, event);
        }
    };
    EditableRow.prototype.onPaste = function (column, clipboardData, event) {
        var onPaste = this.props.onPaste;
        if (onPaste) {
            onPaste(column, clipboardData, event);
        }
    };
    EditableRow.prototype.handleOnSelect = function (column, option, event) {
        var _this = this;
        var record = Object.assign({}, this.state.record);
        record[column.columnKey] = option.code;
        if (column.updateRelatedColumn && column.updateRelatedColumnKey) {
            var usedProp = column.updateRelatedColumnType || 'text';
            if (option[usedProp]) {
                record[column.updateRelatedColumnKey] = option[usedProp];
            }
        }
        this.setState({ record: record }, function () {
            _this.onColumnBlur(column.columnKey, option.code, event);
        });
    };
    // Default props
    EditableRow.defaultProps = {
        enableHtmlEditor: false,
    };
    return EditableRow;
}(React.Component));
exports.EditableRow = EditableRow;
var templateObject_1;
